import { RBAClient } from 'rba-client'

const client = RBAClient.getInstance(require('@/api/config'))

const state = {

}

const getters = {
}

const actions = {
  getForexTransactionStatistics (unusedContext, { startDate, endDate }) {
    return client.transaction_statistic.getForexStatistics(startDate, endDate)
  },
  getForexRiskAggregate (unusedContext, { startDate, endDate }) {
    return client.transaction_statistic.getForexRiskAggregate(startDate, endDate)
  },
  getRemittanceStatistics (unusedContext, { startDate, endDate }) {
    return client.transaction_statistic.getRemittanceStatistics(startDate, endDate)
  },
  getRemittanceRiskAggregate (unusedContext, { startDate, endDate }) {
    return client.transaction_statistic.getRemittanceRiskAggregate(startDate, endDate)
  },
  getRemittanceChannelStatistics (unusedContext, { startDate, endDate }) {
    return client.transaction_statistic.getRemittanceChannelStatistics(startDate, endDate)
  },
  getRemittanceCustomerStatistics (unusedContext, { startDate, endDate }) {
    return client.transaction_statistic.getRemittanceCustomerStatistics(startDate, endDate)
  }
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
